import { VFileInput } from 'vuetify/lib/components/VFileInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFileInput,_vm._b({attrs:{"label":_vm.titulo_label,"prepend-icon":"","append-icon":"mdi-file"},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_vm._t("prepend-inner")]},proxy:true}],null,true),model:{value:(_vm.arquivo),callback:function ($$v) {_vm.arquivo=$$v},expression:"arquivo"}},'v-file-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }